export const LABOR_INTAKE_ROLES = ['manager', 'lawyer', 'intake', 'intern'];

export const laborIntakeSteps = [
  { id: 'client', title: 'بيانات العميل', description: 'البيانات الأساسية للتواصل وربط الطلب بصاحبه.' },
  { id: 'company', title: 'بيانات المنشأة', description: 'معلومات جهة العمل أو المنشأة محل النزاع.' },
  { id: 'contract', title: 'العقد والعلاقة التعاقدية', description: 'تفاصيل العقد، البداية، والانتهاء أو الوضع الحالي.' },
  { id: 'employment', title: 'تحليل العلاقة العمالية والأجر والمستحقات', description: 'تحليل العلاقة الفعلية، الأجر والمزايا، والإجازات والعمل الإضافي والمطالبات المالية.' },
  { id: 'notices', title: 'انتهاء العلاقة والمطالبات', description: 'بيانات انتهاء العلاقة، المراسلات، والمطالبات التي أفاد بها مقدم الطلب.' },
  { id: 'summary', title: 'ملخص البيانات والوقائع', description: 'ملخص منظم للبيانات والوقائع المدخلة قبل المصادقة.' },
  { id: 'attachments', title: 'المرفقات', description: 'رفع المستندات الداعمة وتنظيمها ضمن قائمة واضحة.' },
  { id: 'declaration', title: 'الإقرار النهائي والإرسال', description: 'الإقرار النهائي بصحة البيانات والموافقة على إرسال الطلب.' },
];

export const claimsOptions = [
  'أجور متأخرة',
  'مكافأة نهاية خدمة',
  'رصيد إجازات',
  'ساعات إضافية',
  'عمولات أو حوافز',
  'تعويض عن فصل غير مشروع',
  'بدل إشعار',
  'بدل تذاكر',
  'بدل سكن',
  'بدل نقل',
  'بدل انتداب',
  'فروقات أجور',
  'شهادة خبرة',
  'إخلاء طرف',
  'نقل كفالة',
  'أخرى',
];

export const evidenceOptions = [
  'إشعارات الفصل أو الإنهاء',
  'رسائل واتساب',
  'رسائل بريد إلكتروني',
  'مسيرات رواتب',
  'كشف حساب بنكي',
  'خطابات أو تعاميم داخلية',
  'تكليفات عمل',
  'جداول دوام',
  'إثبات حضور وانصراف',
  'تسجيلات أو محادثات',
  'عقود أو ملاحق',
  'مخالفات أو جزاءات',
  'تقييمات أداء',
  'شهود',
  'صور أو مقاطع',
  'مراسلات الموارد البشرية',
  'أخرى',
];

export const relationIndicators = [
  'ساعات عمل محددة',
  'دوام حضور وانصراف',
  'مدير مباشر',
  'تعليمات يومية',
  'إجازات بموافقة',
  'استخدام أدوات المنشأة',
  'بريد أو هوية وظيفية',
  'راتب شهري ثابت',
  'جزاءات أو إنذارات',
];

export const noticesOptions = [
  'إنذار',
  'لفت نظر',
  'قرار فصل',
  'إشعار عدم تجديد',
  'استدعاء تحقيق',
  'محضر تحقيق',
  'قرار خصم',
  'مخالصة',
  'إخلاء طرف',
  'إيميل رسمي',
  'رسائل واتساب',
  'إشعار قوى أو تأمينات',
];

const createOfficialRecord = () => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  type: '',
  otherName: '',
  number: '',
  issuedBy: '',
  issueDate: '',
});

export const initialLaborIntakeData = {
  client: {
    firstName: '',
    fatherName: '',
    grandfatherName: '',
    familyName: '',
    fullName: '',
    identityType: 'هوية وطنية',
    identityTypeOther: '',
    nationalId: '',
    birthDate: '',
    nationality: '',
    mobile: '',
    email: '',
    city: '',
    jobTitle: '',
    district: '',
    street: '',
    buildingNumber: '',
    additionalNumber: '',
    postalCode: '',
    unitNumber: '',
    currentEmploymentStatus: 'نعم',
    lastWorkingDay: '',
  },
  company: {
    tradeName: '',
    legalName: '',
    headOffice: '',
    directSupervisor: '',
    hrContact: '',
    establishmentType: '',
    establishmentTypeOther: '',
    officialRecords: [createOfficialRecord()],
    licenseNumber: '',
    licenseIssuedBy: '',
    licenseIssueDate: '',
    phone: '',
    email: '',
    website: '',
    companySize: '',
    sector: '',
    sectorOther: '',
  },
  contract: {
    contractType: 'عقد عمل',
    contractTypeOther: '',
    qiwaContract: 'لا أعلم',
    qiwaMatchesReality: 'لا أعلم',
    qiwaSalaryAccurate: 'لا أعلم',
    qiwaTitleAccurate: 'لا أعلم',
    contractCopyAvailable: 'لا أعلم',
    receivedSignedCopy: 'لا أعلم',
    signingMethod: '',
    messagesProofAvailable: 'لا أعلم',
    contractDate: '',
    startDate: '',
    contractDurationType: 'لا أعلم',
    contractEndDate: '',
    trialPeriod: 'لا أعلم',
    trialPeriodLength: '',
    trialPeriodExtended: 'لا أعلم',
    conditionsChanged: '',
    salaryChanged: false,
    titleChanged: false,
    hoursChanged: false,
    workplaceChanged: false,
    dutiesChanged: false,
    otherChanged: false,
    otherChangedDetails: '',
    changeOccurredAt: '',
    changeWasWritten: 'لا أعلم',
    changeApproved: 'لا أعلم',
    changeProofAvailable: 'لا أعلم',
    workPattern: '',
    workPatternDetails: '',
    attendanceSystem: 'لا أعلم',
    workSchedulesAvailable: 'لا أعلم',
    workLocationMode: '',
    directManagerOrders: 'لا أعلم',
    outsideAssignments: 'لا أعلم',
    outsideAssignmentsDetails: '',
    workCommunications: 'لا أعلم',
    verbalInstructions: 'لا أعلم',
    salaryReceiptMethod: 'تحويل بنكي',
    cashPayrollSignoff: 'لا أعلم',
    cashReceiptVoucher: 'لا أعلم',
    cashWitnesses: 'لا أعلم',
    cashMonthlyRegularity: 'لا أعلم',
    dutiesDifferent: 'لا',
    dutiesDifferenceDetails: '',
    outsideAssignmentsCompensated: 'لا أعلم',
    overtimeBeyondAgreed: 'لا أعلم',
    overtimeCompensated: 'لا أعلم',
    salaryDelayRepeated: 'لا أعلم',
    salaryDelayAverage: '',
    salaryDeductionOccurred: 'لا أعلم',
    salaryDeductionExplained: 'لا أعلم',
    unpaidBenefitsOrCommissions: 'لا أعلم',
    unpaidBenefitsDetails: '',
    threatenedOrPressured: 'لا أعلم',
    threatenedOrPressuredDetails: '',
    signedWithoutCopy: 'لا أعلم',
    signedWithoutCopyDetails: '',
    employerCommittedToContract: 'لا أعلم',
    employerBreachDetails: '',
    contractRenewed: '',
    contractRenewalDocument: 'لا أعلم',
    laborIndicators: [],
    currentStatus: 'قائمة',
    lastDay: '',
    terminationMethod: '',
    noticeProvided: 'لا أعلم',
    noticeDeliveryMethod: '',
    noticeDate: '',
    noticePeriod: '',
    noticeCopyRetained: 'لا أعلم',
    releaseReceived: 'لا أعلم',
    releaseDate: '',
    releaseCopyReceived: 'لا أعلم',
    releaseSignedVoluntarily: 'لا أعلم',
    releaseSignedTiming: '',
    releaseFormat: '',
    allDuesPaid: 'لا أعلم',
    signedDocumentsRequested: 'لا أعلم',
    experienceCertificateReceived: 'لا أعلم',
    experienceCertificateDate: '',
    clearanceCompleted: 'لا أعلم',
    clearanceCopyReceived: 'لا أعلم',
    clearanceDate: '',
    endReason: 'ما زالت العلاقة قائمة',
    endStory: '',
    problemSummary: '',
    evidenceSources: [],
    evidenceOther: '',
  },
  employment: {
    relationIndicators: [],
    actualWorkNature: '',
    directSupervisorRole: '',
    fixedHoursCommitment: 'لا أعلم',
    attendanceDepartureTracking: 'لا أعلم',
    workLocationMode: '',
    dailyHours: '',
    weeklyDays: '',
    canRefuseInstructions: 'لا أعلم',
    instructionsNature: '',
    performanceEvaluated: 'لا أعلم',
    extraResponsibilitiesWithoutPay: 'لا أعلم',
    extraResponsibilitiesDetails: '',
    workdayDescription: '',
    otherWork: '',
  },
  compensation: {
    wageType: '',
    basicSalary: '',
    totalSalary: '',
    housingAllowance: '',
    transportAllowance: '',
    mobilityAllowance: '',
    communicationAllowance: '',
    natureAllowance: '',
    assignmentAllowance: '',
    commissionsValue: '',
    incentivesValue: '',
    annualIncrease: '',
    periodicBonuses: '',
    payDate: '',
    wageFixed: 'لا أعلم',
    wageChanged: 'لا أعلم',
    recurringDeductions: 'لا أعلم',
    paymentMethod: 'تحويل بنكي',
    unpaidSalaries: '',
    cashReceiptCopies: 'لا أعلم',
    chequeInYourName: 'لا أعلم',
    chequeCashedFully: 'لا أعلم',
    chequeCopiesAvailable: 'لا أعلم',
    medicalInsurance: 'لا أعلم',
    medicalInsuranceFamily: 'لا أعلم',
    medicalInsuranceStopped: 'لا أعلم',
    contractWageMatchesActual: 'لا أعلم',
    contractWageDifferenceDetails: '',
    gosiWageMatchesActual: 'لا أعلم',
    gosiWageDifferenceDetails: '',
    wageDifferenceReason: '',
    duesDetails: '',
    claims: [],
  },
  benefits: {
    annualLeaveTaken: 'لا أعلم',
    vacationBalance: '',
    leaveCompensated: 'لا أعلم',
    leaveApprovedOfficially: 'لا أعلم',
    overtime: 'لا',
    overtimeHours: '',
    overtimePaid: 'لا أعلم',
    overtimeEvidence: 'لا أعلم',
    overtimeTiming: [],
    weeklyRestDay: '',
    restDayWorked: 'لا أعلم',
    restDayCompensated: 'لا أعلم',
    leaveNotes: '',
  },
  notices: {
    selectedNotices: [],
    signedRelease: 'لا',
    sentObjection: 'لا',
    objectionDate: '',
    objectionMethod: '',
    objectionCopyAvailable: 'لا أعلم',
    employerResponseReceived: 'لا أعلم',
    employerResponseCopyAvailable: 'لا أعلم',
    noticeTimeline: '',
  },
  attachments: {
    items: [],
  },
  summary: {
    approvalStatus: '',
    approvalNote: '',
  },
  declaration: {
    accepted: false,
  },
  narrative: {
    fullStory: '',
    desiredOutcome: '',
    urgency: 'عادية',
  },
};
